<template>
  <div id="app">
    <div class="container">
      <nav id="nav">
        <router-link to="/" class="icon">Théo Grandin <span>- Digital Designer</span></router-link>
        <svg class="close__project" width="18px" height="18px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"  v-show="$route.name === 'Project'">
          <g id="DESKTOP" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" fill-opacity="0.6">
            <g id="Portfolio---Scroll" transform="translate(-711.000000, -42.000000)" fill="#FFFFFF">
              <g id="Header" transform="translate(70.000000, 34.000000)">
                <path d="M650,5 C649.345455,5 648.909091,5.43636364 648.909091,6.09090909 L648.909091,15.9090909 L639.090909,15.9090909 C638.436364,15.9090909 638,16.3454545 638,17 C638,17.6545455 638.436364,18.0909091 639.090909,18.0909091 L648.909091,18.0909091 L648.909091,27.9090909 C648.909091,28.5636364 649.345455,29 650,29 C650.654545,29 651.090909,28.5636364 651.090909,27.9090909 L651.090909,18.0909091 L660.909091,18.0909091 C661.563636,18.0909091 662,17.6545455 662,17 C662,16.3454545 661.563636,15.9090909 660.909091,15.9090909 L651.090909,15.9090909 L651.090909,6.09090909 C651.090909,5.43636364 650.654545,5 650,5 Z" id="Path" transform="translate(650.000000, 17.000000) rotate(-315.000000) translate(-650.000000, -17.000000) "></path>
              </g>
            </g>
          </g>
        </svg>
        <router-link to="/about" class="about" v-if="$route.name !== 'About'">about</router-link>
        <router-link to="/" class="about" v-else>close</router-link>
      </nav>
      <router-view @nextChapter="nextChapter" @fromProject="changeFromProject" ref="mainPage"/>
      <Slider @getVideos="getVideos" v-show="video"></Slider>
    </div>
    <Load v-show='load' ref="loaderView"></Load>
  </div>
</template>

<script>
import Load from '@/components/Partials/Loading.vue'
import Responsive from '@/components/Responsive.vue'
import Slider from '@/components/Partials/Slider.vue'
import Vue from 'vue'
import VueMq from 'vue-mq'

Vue.use(VueMq, {
  breakpoints: {
    sm: 450,
    md: 1024,
    lg: Infinity
  }
})

export default {
  data () {
    return {
      load: true,
      loading: true,
      loader: '',
      loaded: false,
      video: true,
      i: 0,
      fromProject: false,
      fromChapter: false,
      videos: [],
      once: true
    }
  },

  components: {
    Load,
    Responsive,
    Slider
  },

  mounted () {
    if (this.$route.name === 'About') {
      this.video = false
    } else {
      this.video = true
    }
    console.log('coded by me 👀')
  },

  methods: {
    changeFromProject (id) {
      this.fromProject = true
      this.i = id
    },

    nextChapter (id) {
      this.fromChapter = true
      this.i = (id + 1) % 5
    },

    getVideos (e) {
      let video = e.target
      if (this.videos[video.dataset.index] !== video) {
        this.videos[video.dataset.index] = video
        this.$refs.loaderView.timer = this.$refs.loaderView.timer + 20
        if (this.$refs.loaderView.timer === 100) this.loaderEnd()
      }
    },

    loaderEnd () {
      this.loading = false
    },

    afterLoadingIntro () {
      if (this.$route.name === 'Home') {
        this.$nextTick(() => {
          this.$refs.mainPage.transitionEnter('forward')
          this.$refs.mainPage.cleanTitle()
          this.$refs.mainPage.cutTitle('.title__first__line', 'Tesla X')
          this.$refs.mainPage.cutTitle('.title__second__line', 'Iron Man')
        })
      } else if (this.$route.name === 'Project') {
        this.videos[this.$route.params.id].style.opacity = 1
        this.videos[this.$route.params.id].play()
      }
    }
  },

  watch: {
    $route (to, from) {
      if (to.name === 'About') {
        this.video = false
        this.fromProject = false
        this.fromChapter = false
        window.scrollTo(0, 0)
      } else {
        this.video = true
      }
    }
  }
}
</script>

<style lang="scss">

// responsive
$small-phone:325px;
$phone:640px;
$tablet: 768px;
$desktop: 1024px;
$large: 1680px;

// Add fonts
@font-face {
    font-family: 'Tandelle';
    src: url('assets/fonts/Tandelle.woff2') format('woff2'),
        url('assets/fonts/Tandelle.woff') format('woff'),
        url('assets/fonts/Tandelle.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
    font-display: block;
}

@font-face {
    font-family: 'Tandelle';
    src: url('assets/fonts/Tandelle-Bold.woff2') format('woff2'),
        url('assets/fonts/Tandelle-Bold.woff') format('woff'),
        url('assets/fonts/Tandelle-Bold.ttf') format('truetype');
    font-weight: bold;
    font-style: normal;
    font-display: block;
}

@font-face {
  font-family: "DIN Pro";
  src: url("assets/fonts/DINPro.otf");
  font-weight: 400;
  font-display: fallback;
}

@font-face {
  font-family: "DIN Pro";
  src: url("assets/fonts/DINPro-Light.otf");
  font-weight: 300;
  font-display: fallback;
}

@font-face {
  font-family: "DIN Pro";
  src: url("assets/fonts/DINPro-Medium.otf");
  font-weight: 500;
  font-display: fallback;
}

@font-face {
  font-family: "DIN Pro";
  src: url("assets/fonts/DINPro-Bold.otf");
  font-weight: 600;
  font-display: fallback;
}

@font-face {
  font-family: "DIN Pro";
  src: url("assets/fonts/DINPro-MediumItalic.otf");
  font-weight: 500;
  font-style: italic;
  font-display: fallback;
}

//Preset
body
{
  background-image:url("../static/noise.png");
  background-repeat: repeat;
  background-color: #000;
  margin:0;
  height: 100%;
  overflow: hidden;

  div, p, span, a
  {
    -webkit-font-smoothing: antialiased;
  }

  h1, h2, h3, h4
  {
    margin: 0;
  }

  #app
  {
    width:100%;
    height: 100%;

    .container
    {
      width:100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }

  a
  {
    text-decoration: none;
  }

  p
  {
    margin: 0;
  }
}

.paragraph
{
  font-family: "DIN Pro";
  font-size: 16px;
  letter-spacing: 0.4px;
  line-height: 1.5;
  color:#fff;

  @media screen and (max-width:$phone) and (orientation: portrait) {
    font-size: 14px;
    letter-spacing: 0.35px;
  }
}

.subtitle
{
  font-family: "DIN Pro";
  font-size: 16px;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  color:#fff;
  opacity: 0.4;
  white-space: nowrap;

  @media screen and (max-width: $phone) {
    font-size: 12px;
    letter-spacing: 0.4px;
  }

  &.date
  {
    font-size: 18px;
  }
}

.title
{
  font-family: "Tandelle";
  font-weight: bold;
  font-size:120px;
  letter-spacing: 14px;
  text-transform: uppercase;
  color: transparent;
  -webkit-text-stroke: #fff 1.5px;
  text-shadow: 0 2px 10px rgba(0,0,0,0.10);

  @media screen and (min-width:$large){
    font-size: 150px;
  }

  @media screen and (max-width: $phone) {
    font-size: 64px;
    letter-spacing: 6px;
    -webkit-text-stroke: #fff 1px;
  }

  @media screen and (max-width:$small-phone) and (orientation: portrait) {
    font-size: 60px;
  }
}

.bigTitle
{
  font-family: "Tandelle";
  font-weight: bold;
  font-size:150px;
  letter-spacing: 14px;
  text-transform: uppercase;
  color: transparent;
  -webkit-text-stroke: #fff 1.5px;
  text-shadow: 0 2px 10px rgba(0,0,0,0.05);

  @media screen and (max-width: 1300px)
  {
    font-size: 120px;
  }

  @media screen and (max-width: $desktop)
  {
    font-size: 100px;
  }

  @media screen and (max-width: $phone)
  {
    font-size: 56px;
    -webkit-text-stroke: #fff 1px;
    letter-spacing: 7px;
    white-space: nowrap;
  }
}

.flexCenter
{
  display: flex;
  justify-content: center;
  align-items: center;
}

.none
{
  display: none;
}

//nav
#nav
{
  width:calc(100vw - 140px);
  margin: 40px 0px 0px 0px;
  position: fixed;
  left: 70px;
  display: flex;
  justify-content: space-between;
  z-index: 3;

  @media screen and (max-width: $phone)
  {
    margin-top: 32px;
    width:calc(100vw - 48px);
    left: 24px;

    span
    {
      display: none;
    }
  }

  .icon
  {
    font-family: "Tandelle";
    font-size:20px;
    letter-spacing: 1.4px;
    color:#fff;
    text-decoration: none;
    cursor: pointer;
  }

  .about
  {
    font-family: "DIN Pro";
    font-size:16px;
    color:#fff;
    opacity: 0.6;
    text-decoration: none;
    transition:0.4s ease;
    cursor: pointer;

    &:hover
    {
      opacity:1;
    }
  }

  .close__project
  {
    position: fixed;
    top: 40px;
    left: calc(50vw - 9px);
    cursor: pointer;

    @media screen and (max-width: $phone) {
      top: inherit;
    }
  }

}

textarea
{
  position: absolute;
  left: -9999px;
}

</style>



// WEBPACK FOOTER //
// src/App.vue